import React, { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import Toggle from '../../Toggle'

import useStyles from './styles'

const ToggleField = ({
  name,
  isEnabled,
  setFieldValue,
  label,
  labelClassName,
  hasReversedNaming = false,
  fontWeight,
  ...props
}) => {
  const { t } = useTranslation()

  const classes = useStyles({ fontWeight })

  const onToggleHandler = useCallback(() => {
    if (hasReversedNaming) {
      setFieldValue(name, isEnabled)
    } else {
      setFieldValue(name, !isEnabled)
    }
  }, [name, isEnabled, setFieldValue, hasReversedNaming])

  return (
    <div className={classes.container}>
      <Toggle isEnabled={isEnabled} onToggle={onToggleHandler} {...props} />
      <span className={classnames(labelClassName, classes.label)} onClick={onToggleHandler}>
        {t(label)}
      </span>
    </div>
  )
}

ToggleField.propTypes = {
  name: PropTypes.string,
  isEnabled: PropTypes.bool,
  setFieldValue: PropTypes.func,
  label: PropTypes.string,
  labelClassName: PropTypes.string,
  hasReversedNaming: PropTypes.bool
}

export default ToggleField
